import api from '@/utils/api';

/**
 * Update Company Currency
 * @param {string} companyId the company id
 * @param {object} data - The Company currency data
 * @returns {Promise}
 */
const updateCompanyCurrencyApi = (companyId, data) =>
  api.patch(`/company/${companyId}/currency`, data);

export default updateCompanyCurrencyApi;
